module.exports = __webpack_public_path__ + "img/swissbilling.e6f0baa2.svg";